import type { FaireProductEntity } from "../../entity_types/product";

export const p_3c984rvp9m: FaireProductEntity = {
  token: "p_3c984rvp9m",
  type: "product",
  name: "Coconut & Vanilla Basket – For Sample (1 Basket)",
  brandToken: "b_hyqrkm9hrr",
  brandName: "Jane and Bloom USA",
  imageUrl:
    "https://cdn.faire.com/fastly/e1199bc58579af08af927e98c3befe13d2f9d2048ff2e6ba99b5365451d545ab.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/b2bd63af407c782fbce34a209ced24e66ee43bee16bb9420046dabb57ebaff9c.png",
    "https://cdn.faire.com/fastly/677914366bbc13255278be5257a6234fbb3e7e9975cbab42e6b34be14171475a.png",
    "https://cdn.faire.com/fastly/b89c41d4426bb690108b2f7d03486fa8433cd110cd4eaf06317241c456b1e36c.png",
    "https://cdn.faire.com/fastly/86b8fc42721b4bb181532e145c4427322038cce490e04a2232b81f36dbe6b43e.png",
  ],
  priceDollars: 34.99,
  description:
    "Flowers capture the heart, but this basket completes the gift. Wrapped in creamy vanilla and kissed with coconut, this 12-piece spa collection feels like a mini vacation at home. Beautifully hand-woven and finished with a satin bow, it is shelf-ready, instantly giftable, and designed to sit perfectly beside a bouquet.\n\nInside she’ll unwrap: shower gel, bubble bath, shampoo, diffuser oil, body scrub, body lotion, bath salt, two fizzy bath bombs, a bath puff, golden eye mask, spa headband — all curated to soothe, pamper, and delight the senses.\n\nWhy florists love it: Customers often wonder if flowers alone are “enough.” This basket removes that hesitation by completing the gesture — creating a more indulgent, lasting experience. It doubles the impact of every bouquet, raises average order value, and makes your shop stand out with premium gifting options. Flowers fade within days, but this basket extends the memory with every scent and soak.",
  tags: [],
  msrpDollars: 90,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T05:53:18.332Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
